module.exports = __webpack_public_path__ + "static/media/screen_one.f926ab98.png";